'use client';

import styled from 'styled-components';

import { breakpoints } from '@/styles/theme';

export const CounterContainer = styled.div`
  display: flex;
  flex-wrap: wrap;

  width: 100%;
  gap: 16px;
  margin-bottom: 6vh;

  @media (max-width: ${breakpoints.mobile}) {
    justify-content: center;

    padding: 8px;
  }
`;
